import { ROUNDING_OPTIONS } from "../lib/roundup";
import { updateSettings, useAppState } from "../lib/store";

const STOCKS = [
  { symbol: "NVDA", name: "NVIDIA" },
  { symbol: "AAPL", name: "Apple" },
  { symbol: "TSLA", name: "Tesla" },
  { symbol: "SPY", name: "S&P 500 ETF" },
];

export function InvestScreen() {
  const s = useAppState();

  return (
    <div className="screen">
      <h1>Invest</h1>
      <p className="sub">Every round-up buys this. One stock at a time for now.</p>

      <h2>Selected stock</h2>
      <div className="option-list">
        {STOCKS.map((stock) => (
          <button
            key={stock.symbol}
            className={`option ${s.settings.stockSymbol === stock.symbol ? "selected" : ""}`}
            onClick={() => void updateSettings({ stockSymbol: stock.symbol })}
          >
            <span>
              {stock.symbol}
              <span className="option-sub">{stock.name}</span>
            </span>
            {s.settings.stockSymbol === stock.symbol && <span className="tick">✓</span>}
          </button>
        ))}
      </div>

      <h2>Round up to</h2>
      <div className="option-list">
        {ROUNDING_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            className={`option ${s.settings.incrementPence === opt.value ? "selected" : ""}`}
            onClick={() => void updateSettings({ incrementPence: opt.value })}
          >
            <span>{opt.label}</span>
            {s.settings.incrementPence === opt.value && <span className="tick">✓</span>}
          </button>
        ))}
      </div>

      <p className="sub" style={{ marginTop: 16 }}>
        Example: a £3.42 coffee rounds to £4.00 — 58p goes into {s.settings.stockSymbol}. Exact-pound
        purchases invest nothing.
      </p>
    </div>
  );
}
